<template>
  <div class="page-blank">Page loading...</div>
</template>

<script>
export default {}
</script>
